import { Helmet } from 'react-helmet-async'
import { Link, useLocation } from 'react-router-dom'
import { buildLocaleSeoLinks } from '@/i18n/seo'
import { resolveLocaleFromPath, toCurrentLocalePath } from '@/i18n/routing'
import { getPrivacyPageContent } from './content'

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://toolvance.com'

export function PrivacyPage() {
  const { pathname } = useLocation()
  const seoLinks = buildLocaleSeoLinks(pathname, SITE_URL)
  const localize = (path: string) => toCurrentLocalePath(pathname, path)
  const { locale } = resolveLocaleFromPath(pathname)
  const content = getPrivacyPageContent(locale)

  const updatedDate = new Date().toLocaleDateString(content.dateLocale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <>
      <Helmet>
        <title>{content.title}</title>
        <meta name="description" content={content.description} />
        <link rel="canonical" href={seoLinks.canonicalUrl} />
        {seoLinks.alternates.map(alt => (
          <link key={alt.locale} rel="alternate" hrefLang={alt.hreflang} href={alt.href} />
        ))}
        <link rel="alternate" hrefLang="x-default" href={seoLinks.xDefaultUrl} />
        <meta property="og:title" content={content.metadata.ogTitle} />
        <meta property="og:description" content={content.metadata.ogDescription} />
        <meta property="og:url" content={seoLinks.canonicalUrl} />
        <meta name="robots" content={content.metadata.robots} />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose">
        <h1>{content.content.heading}</h1>
        <p>{content.content.updatedLabel}: {updatedDate}</p>
        {content.content.sections.map(section => (
          <section key={section.heading}>
            <h2>{section.heading}</h2>
            <p>{section.body}</p>
          </section>
        ))}
        <h2>{content.content.contactHeading}</h2>
        <p>
          {content.content.contactPrefix}
          <Link to={localize('/contact')}>{content.content.contactLinkText}</Link>
          {content.content.contactSuffix}
        </p>
      </div>
    </>
  )
}
